const TimeUnits = [
  { label: 'ano', seconds: 31536000 },
  { label: 'mês', seconds: 2592000 },
  { label: 'semana', seconds: 604800 },
  { label: 'dia', seconds: 86400 },
  { label: 'hora', seconds: 3600 },
  { label: 'minuto', seconds: 60 },
  { label: 'segundo', seconds: 1 },
] as const

const calculateTimeUnit = (time: number) => {
  for (const { label, seconds } of TimeUnits) {
    const interval = Math.floor(time / seconds)
    if (interval >= 1) {
      return {
        interval: interval,
        unit: label,
      }
    }
  }
  return {
    interval: 0,
    unit: '',
  }
}

export const relativeTimeFromNow = (date: number) => {
  const time = Math.floor((new Date(Date.now()).valueOf() - new Date(date).valueOf()) / 1000)
  const { interval, unit } = calculateTimeUnit(time)
  let suffix = ''
  if (interval > 1) {
    if (unit === 'mês') return `${interval} meses atrás`
    suffix = suffix.concat('s')
  }

  if (interval) {
    return `${interval} ${unit}${suffix} atrás`
  }

  return 'agora'
}
